// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }

// 获取图书列表（精品淘题）
export function bookList(token, data) {
  return request({
    url: "/api/book/index",
    method: "post",
    data,
    headers: { token },
  });
}

// 获取图书详情（精品淘题）
export function bookInfo(token, data) {
  return request({
    url: "/api/book/info",
    method: "post",
    data,
    headers: { token },
  });
}

// 图书增值详情文件下载
export function downloadAddServices(data) {
  return request({
    url: "/api/book/get_resource_flie",
    method: "post",
    data,
    // responseType:"blob"
  });
}




// 必备好书
export function bookRecommend(params) {
  return request({
    url: "/api/book/recommend",
    method: "get",
    params,
  });
}

// 新书推荐
export function bookNew(params) {
  return request({
    url: "/api/book/new",
    method: "get",
    params,
  });
}


// 详情页取消收藏
export function cancelCollect(token,data) {
  return request({
    url: "/api/user_favorites/cancel",
    method: "post",
    data,
    headers:{
      token,
      // "Content-Type":"multipart/form-data"
     },
  });
}